const msg_codeEN = {
    MSG_CODE_001:'The user name or password error',
    MSG_CODE_002:'Token failure',
    MSG_CODE_003:'Token illegal',
    MSG_CODE_004:'Authorization failure',
    MSG_CODE_005:'Please enter the account',
    MSG_CODE_006:'Account does not exist',
    MSG_CODE_007:'Password back',
    MSG_CODE_008:'Account cannot be empty',
    MSG_CODE_009:'The current account has been in existence',
    MSG_CODE_010:'Registration verification code',
    MSG_CODE_011:'Send Success!',
    MSG_CODE_012:'Registered Successfully!',
    MSG_CODE_013:'Registration Failed!',
    MSG_CODE_014:'Access Errors',
    MSG_CODE_015:'Password cannot be empty',
    MSG_CODE_016:"The two passwords don't match",
    MSG_CODE_017:'Modification time has expired',
    MSG_CODE_018:'Change the password failure',
    MSG_CODE_019:'No more',
    MSG_CODE_020:'The user has been disabled',
    MSG_CODE_021:'Account is out of service',
    MSG_CODE_022:'No query to the social information',
    MSG_CODE_023:'Invitation has been sent',
    MSG_CODE_024:'Please first selected data',
    MSG_CODE_025:'The export file format error',
    MSG_CODE_026:'Unknown derived type',
    MSG_CODE_027:'Could not find the data',
    MSG_CODE_028:'Not to query to the contact information, the view line of travel',
    MSG_CODE_029:'The new password cannot be same as old password',
    MSG_CODE_030:'There is no account',
}
export default msg_codeEN


// WEBPACK FOOTER //
// ./src/lan/en/en_msg_code.js